// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"faa2211dd83bb29f56c7","678":"34f44e443b21788ddcd9","883":"05aaa891498a2f4f4896"}[chunkId] + ".js";
};